import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { OwnersQuery } from "../../../graphql/deliveryService/queries/owners";
import { OwnersPagedFragment } from "../../../models/autogenerated-deliveryService-gql/graphql";
import { handleError } from "../../../utils/graphqlHelper";
import { isNullOrEmpty } from "../../../utils/helper";

interface useOwnersQueryProps {
  locationId: string;
  dataAction: (data: OwnersPagedFragment) => void;
  errorAction?: () => void;
}

const useOwnersQuery = (props: useOwnersQueryProps) => {
  const { t } = useTranslation();
  const { locationId, dataAction, errorAction } = props;

  const query = useQuery(OwnersQuery, {
    skip: isNullOrEmpty(locationId),
    variables: { locationId, offset: 0, limit: 50 },
  });

  const { data, error } = query;

  const ownersPagedFragment = data?.owners;

  useEffect(() => {
    if (!error) return;

    handleError(t("ownersError"), error.message, errorAction);
  }, [error]);

  useEffect(() => {
    if (!data || !ownersPagedFragment) return;

    dataAction(ownersPagedFragment);
  }, [data]);

  return query;
};

export default useOwnersQuery;
